import { useEffect } from 'react';
import { FEATURE_FLAGS } from '@highmark-web/highmark-common';
import { useGetAppFeatureFlag } from 'hooks/use-get-app-feature-flag.hook';
import { documentCenter } from '@leagueplatform/engen-capability-document-center';

export const useDynamicEnGenConfig = () => {
  const { isEnabled: isUMEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_UM_LETTERS,
  );
  const { isEnabled: isWelcomeGuidesEnabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_CENTER_WELCOME_GUIDES,
  );

  useEffect(() => {
    const dynamicFeatureFlags = {
      enableUMLetters: isUMEnabled,
      enableWelcomeGuides: isWelcomeGuidesEnabled,
    };

    documentCenter.config(dynamicFeatureFlags);
  }, [isUMEnabled, isWelcomeGuidesEnabled]);
};
